import React from 'react';
import Highlight from '../../components/Highlight';
import variables from '../../styles/variables.module.scss';

import extraimg1 from '../../assets/frames/inspospotr-extraimg1@2x-min.png';
import extraimg2 from '../../assets/frames/inspospotr-extraimg2@2x-min.png';
import extraimg3 from '../../assets/frames/inspospotr-extraimg3@2x-min.png';
import footerBanner from '../../assets/envImages/inspospotr-footerBanner-min.jpg';
import hero from '../../assets/hero/inspospotr-hero-min.jpg';

export default {
  key: 'inspospotr',
  path: '/cases/inspospotr',
  color: variables.inspospotr,
  title: 'Inspospotr',
  hero: { fall: hero },
  footerBanner: { fall: footerBanner },
  xtra: [
    { fall: extraimg1 },
    { fall: extraimg2 },
    { fall: extraimg3 },
  ],
  titleBodyData: {
    0: {
      title: 'Assisted Online Shopping',
      body:
  <span>
    Inspospotr is a Gothenburg-based startup, born and grown through the participation in some of Sweden’s most prestigious startup incubators and startup competitions.
    <br />
    <br />
    What Inspospotr has developed, is a fully automated digital assistant service, that can assist you with purchase recommendations, tailored to your specific needs and preferences.
    Using voice or free text, users can interact with the AI, who understand both written or spoken language. The assistant can then help scour the entire web for product recommendations that fit the request of the user.
    <br />
    <br />
    All of this power is placed immediately at the fingertip of the user, as the AI exist directly within Facebook Messenger. With their service, Inspospotr is aiming to create the future of automated and assisted online shopping.
  </span>,
    },
  },
  quoteData: {
    quote: 'We App got the tough challenge to go into a very new and complex area, that we believe will change the way Ecommerce works. We felt that We app put the best possible people on the job, and always stayed on top of the complex technologies we presented them with. It\'s crazy to be able to talk to a computer, and it\'s all thanks to We app.',
    name: 'Fredrik Göthensten',
    profession: 'Co-Founder, Inspospotr',
  },
  sideHeadingFirst: 'Web app & Facebook application',
  sideHeadingSecond: 'Developed in React Native',
  infoTitle: 'What we built',
  infoBody:
  <span>
    The intelligent shopping assistant has been trained in
    {' '}
    <Highlight>Natural Language Processing</Highlight>
    {' '}
(NLP), leveraging the NLP frameworks of both Microsoft LUIS and Google Dialogflow.
    The NLP capabilities were connected to web-scraping technologies, that could instantly provide users with access to product recommendations from across the web.
    A product recommendation algorithm was built, so that the assistant learns about user preferences over time, and subsequently can provide even better recommendations.
    <br />
    <br />
    Lastly, the service was implemented immediately within
    {' '}
    <Highlight>Facebook Messenger</Highlight>
, using Facebook API services, to provide users with easy and instant access to the service, without having to download an app or create an account.
    <br />
    <br />
    Tech stack used was:
    {' '}
    <Highlight>React Native, Nodejs, Google Dialogflow (NLP), Microsoft LUIS (NLP), Facebook developer API</Highlight>
.
  </span>,
  infoData: {
    Scope: ['Scope', 'Project management', 'User experience', 'UI & UX design'],
    Deliverables: ['Deliverables', 'iOS development', 'Android development', 'Cross-platform', 'Software development'],
    Goal: ['Goal', 'Project management', 'User experience', 'UI & UX design', 'Maintanance/support'],
  },
};
